import { useaxios } from "../../../utils/useaxios";
export default (sell_invoice_id, return_invoice_note, items, user_id) => recaller => setrecaller => initDispatch => clear => {
    var today = new Date();
    today = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate() + " " + today.getHours() + ":" + today.getMinutes() + ":" + today.getMinutes();
    initDispatch({ type: 'loadingTrue' });
    useaxios('return_invoice/create.php', { return_invoice_date: today, sell_invoice_id, return_invoice_note, items, user_id }).then((res) => {
        if (res == "auth_failed") {
            alert('no internet connection');
            initDispatch({ type: 'loadingFalse' });
            return false;
        }
        if (res.status == "ok") {
            initDispatch({ type: 'setreturnbybarcode', payload: [] });
            setrecaller(recaller + 1);
        } else {
            // clear();
        }
        // setloading(false);
    });
}